import { JSXElement, Switch } from 'solid-js';

function Box(props: {
  children: JSXElement;
  title: JSXElement;
  defaultOpen?: boolean;
  class?: string;
  isNeedToggle?: boolean;
  icon?: JSXElement;
  type?: 'default' | 'none' | 'dark';
}) {
  const CONFIG = {
    default: {
      bg: 'bg-layer6',
      titleBg: 'bg-layer7',
    },
    dark: {
      bg: 'bg-layer6',
      titleBg: 'bg-layer3',
    },
    none: {
      bg: '',
      titleBg: '',
    },
  } as const;

  const [isShowChild, setShowChild] = createSignal(props.defaultOpen ?? true);

  function handleToggleBox() {
    setShowChild(!isShowChild());
  }

  const config = CONFIG[props.type ?? 'default'];

  return (
    <Switch
      fallback={
        <section
          class={cx(`overflow-hidden rounded-lg border border-main3`)}
          style={{
            'box-shadow': '0px 3px 12px 0px rgba(0, 12, 20, 0.04)',
          }}
        >
          <h2
            class={cx(
              'h-9 px-4 py-2.5 font-semibold text-neutral-main3 flex items-center justify-between ',
              config.titleBg
            )}
            style="box-shadow:0 2px 12px 0 rgba(0, 0, 0, 0.05)"
          >
            {props.title}
          </h2>

          <div class={cx('p-4 space-y-4 bg-layer6', props.class)}>{props.children}</div>
        </section>
      }
    >
      <Match when={props.type === 'none'}>
        <div class={props.class}>{props.children}</div>
      </Match>
      {/* 样式结构差异大，另开一个Match */}
      <Match when={props.isNeedToggle}>
        <section class={cx(`overflow-hidden rounded-lg bg-alpha-neutral-autowhite-a2`)}>
          <h2
            class={cx(
              'px-4 py-2.5 font-semibold text-neutral-main1 flex items-center justify-between bg-layer4',
              isShowChild() ? 'border-b border-main1-auto' : ''
            )}
          >
            <div class="flex-auto ">{props.title}</div>
            {props.icon}
            <span class="ml-2 cursor-pointer text-neutral-main1_alt" onClick={() => handleToggleBox()}>
              {isShowChild() ? <IconCountMinus class="size-6" /> : <IconCountPlus class="size-6" />}
            </span>
          </h2>

          <Show when={isShowChild()}>
            <div class=" w-full h-px bg-layer5-card"></div>
            <div class={cx('p-4 space-y-4', props.class)}>{props.children}</div>
          </Show>
        </section>
      </Match>
    </Switch>
  );
}

export default Box;
